var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-tabs",
        { attrs: { type: "border-card" } },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("collectionCenter.PickupCodeDetails") } },
            [
              _c(
                "div",
                { staticClass: "constant-detail" },
                [
                  _c(
                    "el-form",
                    { attrs: { size: "small" } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 10 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label:
                                      _vm.$t("collectionCenter.PickupCode") +
                                      "：",
                                  },
                                },
                                [_c("span", [_vm._v(_vm._s(_vm.rowData.code))])]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label:
                                      _vm.$t("collectionCenter.belongD") + "：",
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.rowData.siteName)),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label:
                                      _vm.$t("GlobalSetObj.nextStation") + "：",
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.rowData.nextStationName)),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label:
                                      _vm.$t("collectionCenter.CreationTime") +
                                      "：",
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.rowData.createTime)),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label:
                                      _vm.$t("collectionCenter.creator") + "：",
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.rowData.createUserName)),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label:
                                      _vm.$t("collectionCenter.stateZT") + "：",
                                  },
                                },
                                [
                                  _vm.rowData.status === 0
                                    ? _c(
                                        "el-tag",
                                        { attrs: { type: "info" } },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "collectionCenter.NotBound"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.rowData.status === 1
                                    ? _c(
                                        "el-tag",
                                        { attrs: { type: "success" } },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("collectionCenter.Bound")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.rowData.status === 2
                                    ? _c(
                                        "el-tag",
                                        { attrs: { type: "primary" } },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("GlobalSetObj.Carregado")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label:
                                      _vm.$t("collectionCenter.BoundBags") +
                                      "：",
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.rowData.boundBagCount)),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label:
                                      _vm.$t("collectionCenter.BoundPackages") +
                                      "：",
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.rowData.boundPackageCount)
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label:
                                      _vm.$t("collectionCenter.totalWeight") +
                                      "：",
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.rowData.totalWeight) + "KG"
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label:
                                      _vm.$t(
                                        "collectionCenter.TotalInvoiceAmount"
                                      ) + "(BRL)：",
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.rowData.totalInvoiceAmount)
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("collectionCenter.BoundBagNumber") } },
            [
              _c(
                "div",
                { staticClass: "constant-detail" },
                [_c("bagNumber", { attrs: { "row-data": _vm.rowData } })],
                1
              ),
            ]
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("collectionCenter.BoundPackageNumber") } },
            [
              _c(
                "div",
                { staticClass: "constant-detail" },
                [_c("packageNumber", { attrs: { "row-data": _vm.rowData } })],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }